var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40909 16L0.5 12V4L7.40909 0L14.3182 4V12L7.40909 16ZM7.40909 1.68145L1.95455 4.83855V11.1615L7.40909 14.3193L12.8636 11.1615V4.83855L7.40909 1.68073V1.68145ZM7.40909 10.9091C6.63781 10.9069 5.8985 10.6006 5.35164 10.0567C4.51981 9.22465 4.27109 7.97344 4.72144 6.88649C5.17179 5.79953 6.23253 5.09091 7.40909 5.09091C8.18019 5.09298 8.91931 5.39929 9.46582 5.94327C10.6015 7.07927 10.6015 8.92073 9.46582 10.0567C8.91917 10.6005 8.18014 10.9068 7.40909 10.9091ZM7.40909 6.54545C6.71516 6.54531 6.11775 7.03538 5.98224 7.71595C5.84672 8.39652 6.21084 9.07805 6.8519 9.34372C7.49297 9.6094 8.23243 9.38523 8.61805 8.8083C9.00368 8.23138 8.92807 7.4624 8.43745 6.97164C8.16528 6.69802 7.79502 6.54457 7.40909 6.54545Z",
    fill: "#363740"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavSettings);
export default __webpack_public_path__ + "static/media/navSettings.f84cf19126f3006d24899196458aa8b2.svg";
export { ForwardRef as ReactComponent };